export default {

  feedBackTypes: [],
  feedBackTypeCode: null,

  feedBack: [],
  feedBackItem: {},
  feedBackCode: null,
  feedBackId: null,


  feedbackQuestion: [],

  feedbackAnswers: [],
  feedbackAnswer: {},
  feedbackAnswerId: null,
 

  feedbackQuestionOptions: [],
  feedbackQuestionOption: {},

  personClubGroup: [],
  personClubGroupCode: null,

  salesChannel: [],
  salesChannelCode: null,

  introducedType: [],
  introducedTypeCode: null,

  customerTag: [],
  customerTagCode: null,

  occasionType: [],
  occasionTypeCode: null,

  deliveryMethods: [],
  deliveryMethodCode: null,

  paymentMethods: [],
  paymentMethodCode: null,

  discounts: [],
  discount: {},
  discountCode: null,
  validateDiscountCode: null,
  personsClub: [],
  personClub: {},
  personClubCode: null,
  personClubByMobile: {},
  personClubModal: false,
  personSearchSuccess: false,
  personClubSearch: {},

  smsSetting: [],
  smsSettingById: {},

  processes: [],
  process: {},
  processCode: null,

  scoreTransaction: [],
  creditTransaction: [],
  validateCreditCode: null,

  purchases: [],
  purchase: {},
  purchaseSearchByMobile: {},

  personClubGrades: [],
  personClubGradeCode: null,

  personClubPurchase: [],

  customerPurchaseReport: [],

  scoreSummery: [],

  mostCustomerRegistrations: [],

  requirementProfile: {},

  apiKeyAccess: [],

  feedbackReport: [],
  feedbackDetailReport: [],
  personClubFeedbackReport: [],
  personClubFeedbackLog: [],
  answerPersonClub: [],
};
